<template>
  <el-row :gutter="20">
    <header class="header">
      <img src="../assets/zf-logo.png" width="100">
      <h1>中国房地产测评系列榜单后台登录</h1>
    </header>
    <div class="main">
      <el-col :span="12" :offset="6">
        <div class="grid-content bg-purple">
          <div class="login">
              <form>
                <el-input v-model="name" name="name" placeholder="请输入用户名"></el-input>
                <el-input type="password" v-model="password" name="password" placeholder="请输入密码"></el-input>
                <el-button type="primary" @click="userVerify">登录</el-button>
              </form>
            </div>
        </div>
      </el-col>
    </div>
  </el-row>

</template>
<script>
export default {
  name: 'login',
  data () {
    return {
      name: '',
      password: ''
    }
  },
  mounted: function(){
    var that = this;
    that.setHeight();
    $(window).resize(function(){
      that.setHeight();
    });
  },
  methods: {
    userVerify() {
      var name = this.name;
      var password = this.password;
      var data = {
        name: name,
        pew: password
      }
      this.$store.dispatch('Logins',data).then(res => { 
          this.$http.get('/api/user/verify', {params:{name: name, password: password}}).then((response) => {
            console.log(response);
            if(response.ok){
                this.$router.push({ path: '/admin/list' });
            }
          })
        }).catch(() => {
      })

      
    },
    setHeight (){
      var height = window.innerHeight - 370;
      $('.main').css('min-height', height + 'px');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue